const WILL_VISITED = { id: 'WILL_VISITED', label: 'fleetTaskInstant.pointStatus.willVisited'}
const VISITING = { id: 'VISITING', label: 'fleetTaskInstant.pointStatus.visiting' }
const MISSED_VISIT = { id: 'MISSED_VISIT', label: 'fleetTaskInstant.pointStatus.missedVisit' }
const NOT_VISITED = { id: 'NOT_VISITED', label: 'fleetTaskInstant.pointStatus.notVisited' }
const VISITED = { id: 'VISITED', label: 'fleetTaskInstant.pointStatus.visited'}
const POTENTIAL_ON_TIME = { id: 'POTENTIAL_ON_TIME', label: 'fleetTaskInstant.pointStatus.potentialOnTime' }
const ON_TIME = { id: 'ON_TIME', label: 'fleetTaskInstant.pointStatus.onTime'}
const POTENTIAL_LATE = { id: 'POTENTIAL_LATE', label: 'fleetTaskInstant.pointStatus.potentialLate' }
const LATE = { id: 'LATE', label: 'fleetTaskInstant.pointStatus.late'}

const status = {
  WILL_VISITED,
  VISITING,
  MISSED_VISIT,
  NOT_VISITED,
  VISITED,
  POTENTIAL_ON_TIME,
  ON_TIME,
  POTENTIAL_LATE,
  LATE,
}

export const statusIdToLabelMap = {
  [WILL_VISITED.id]: WILL_VISITED.label,
  [VISITING.id]: VISITING.label,
  [MISSED_VISIT.id]: MISSED_VISIT.label,
  [VISITED.id]: VISITED.label,
  [NOT_VISITED.id]: NOT_VISITED.label,
  [POTENTIAL_ON_TIME.id]: POTENTIAL_ON_TIME.label,
  [ON_TIME.id]: ON_TIME.label,
  [POTENTIAL_LATE.id]: POTENTIAL_LATE.label,
  [LATE.id]: LATE.label,
}

export default status